export default __webpack_public_path__ + "static/media/ic-favorites.16f7852e.svg";